import { Component, Inject, ViewChild, PLATFORM_ID } from '@angular/core';
import { FooterBasicComponent } from "src/app/components/shared/footer-basic/footer-basic.component";
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'app-shared',
    templateUrl: './shared.component.html'
})
export class SharedComponent {
    @ViewChild('footer', { static: false }) footer?: FooterBasicComponent;
    constructor(private router: Router, @Inject(PLATFORM_ID) private platform: Object) {}
  
    ngOnInit(): void {
      if (isPlatformBrowser(this.platform)) {
        this.router.events.subscribe((evt) => {
          if (!(evt instanceof NavigationEnd)) return;
  
        //   if (evt.url != '/app/dashboard') this.footer.isCollapsed = true;
        });
      }
    }
}